import React from 'react';
export function StickyAlertBar() {
  const messages = ['🔥 SOLO POR HOY +7 BONOS GRATIS 🔥', '⭐ ACCESO INMEDIATO AL SISTEMA COMPLETO ⭐', '🎉 OFERTA DE LANZAMIENTO DISPONIBLE 🎉'];
  return <div className="fixed top-0 left-0 w-full z-50 rainbow-gradient-animated text-white py-1.5 overflow-hidden shadow-sm" data-id="element-331">
      <div className="flex whitespace-nowrap animate-marquee" data-id="element-332">
        {[...Array(4)].map((_, arrayIndex) => <div key={arrayIndex} className="flex items-center" data-id="element-333">
            {messages.map((msg, idx) => <span key={`${arrayIndex}-${idx}`} className="mx-8 font-bold text-xs md:text-sm tracking-wide text-white" data-id="element-334">
                {msg}
              </span>)}
          </div>)}
      </div>
    </div>;
}